import type {
  ExperienceActionType,
  ExperienceEvent,
  ExperienceEventPayload,
} from '../types/experienceEngine'

type ExperienceEventListener = (event: ExperienceEvent) => void

const listeners = new Set<ExperienceEventListener>()
const startupBacklog: ExperienceEvent[] = []

export const createExperienceEventId = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `experience-${Date.now()}-${Math.round(Math.random() * 1e9)}`

export const emitExperienceEvent = (
  actionType: ExperienceActionType,
  payload: ExperienceEventPayload = {},
): ExperienceEvent => {
  const event: ExperienceEvent = {
    eventId: createExperienceEventId(),
    actionType,
    payload,
    occurredAt: new Date().toISOString(),
  }
  if (listeners.size === 0) startupBacklog.push(event)
  listeners.forEach((listener) => {
    try {
      listener(event)
    } catch (error) {
      console.warn('[ExperienceEvents] listener failed', error)
    }
  })
  return event
}

export const subscribeExperienceEvents = (listener: ExperienceEventListener): (() => void) => {
  listeners.add(listener)
  startupBacklog.splice(0).forEach((event) => listener(event))
  return () => listeners.delete(listener)
}
